export default function getTextWidth(text: string, font: string) {
  const canvas =
    (getTextWidth as any).canvas ||
    ((getTextWidth as any).canvas = document.createElement("canvas"));
  const context = canvas.getContext("2d");
  context.font = font;
  const metrics: any = context.measureText(text);
  return metrics.width;
}
